export default function isValidMediaUrl(urlStr, type) {
  if (!URL.canParse(urlStr)) return false;

  const { protocol, hostname, pathname } = new URL(urlStr);

  if (protocol !== "http:" && protocol !== "https:") return false;

  if (!hostname.endsWith(".org")) return false;

  const mediaExtensions = {
    audio: /\/[^/]+\.(mp3|wav|ogg|aac|flac|m4a)$/i,
    video: /\/[^/]+\.(mp4|webm|ogg|mov|avi|wmv)$/i,
  };

  const mediaType = mediaExtensions[type];
  if (!mediaType) return false;

  return mediaType.test(pathname);
}
